import {DialogActions, DialogTitle, Button} from "@mui/material";
import {Dialog2} from "../../../misc/Dialog2";
import {useProjectId} from "../shopdrawing/ProjectName";
import {api} from "../../../api/API";
import {DynamicProductError} from "../../../api/Products";
import {StringCol, Table} from "../../../misc/scroller/Table";
import {PopperZIndexProvider} from "../../../misc/scroller/PopperZIndexProvider";

type DynamicProductErrorRow = DynamicProductError & {id: number};

export function DynamicErrorsDialog(props: {
    onClose(): void;
}) {
    const project = useProjectId();

    return (
        <Dialog2 open onClose={props.onClose} maxWidth="lg" fullWidth>
            <DialogTitle>Dynamic Errors</DialogTitle>
            <PopperZIndexProvider value={1400}>
                <div style={{display: "flex", flexDirection: "column", minHeight: 400, maxHeight: "60vh"}}>
                    <Table<DynamicProductErrorRow>
                        name="product.dynamic-errors"
                        columns={[
                            StringCol("Opening", "openingName"),
                            StringCol("HW", "hardwareGroupName", 50),
                            StringCol("Category", "productCategory", 180),
                            StringCol("Code", "productCode", 200),
                            StringCol("Error", "error", 400),
                        ]}
                        fetch={async () => api.products.dynamicErrors({project})}
                        fetchDeps={[project]}
                    />
                </div>
            </PopperZIndexProvider>
            <DialogActions>
                <Button onClick={props.onClose}>Close</Button>
            </DialogActions>
        </Dialog2>
    );
}
